import { useTranslation } from 'react-i18next'
import { Dialog, DialogContent, DialogTitle } from '../dialog'
import { PreferencesShell } from '../../common/preferences/PreferencesShell'

interface PreferencesDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
}

/**
 * Web-modal host for the Preferences UI. Renders {@link PreferencesShell}
 * inside a Radix Dialog. The shell already provides its own TopNav (which
 * doubles as the visual title), so the Dialog header is dropped — a
 * visually-hidden title still ships for screen readers.
 *
 * Counterpart for Electron: {@link PreferencesPage} (separate window).
 */
export function PreferencesDialog({ open, onOpenChange }: PreferencesDialogProps) {
  const { t } = useTranslation()

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="preferences-dialog-content w-[960px] max-w-[95vw] h-[640px] max-h-[90vh] p-0 overflow-hidden">
        <DialogTitle className="sr-only">{t('settings.title')}</DialogTitle>
        <PreferencesShell platform="web" />
      </DialogContent>
    </Dialog>
  )
}
